import { render } from "./main_menu.vue?vue&type=template&id=76d33534&scoped=true&lang=pug"
import script from "./main_menu.vue?vue&type=script&setup=true&lang=js"
export * from "./main_menu.vue?vue&type=script&setup=true&lang=js"

import "./main_menu.vue?vue&type=style&index=0&id=76d33534&scoped=true&lang=css"

import exportComponent from "../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76d33534"]])

export default __exports__